import * as z from "zod";
import { IMPLEMENTED_VIP_CRITERIA } from "./criteria";

export const RecognizeVipCriterion = z.enum(IMPLEMENTED_VIP_CRITERIA);
export type RecognizeVipCriterion = z.infer<typeof RecognizeVipCriterion>;

export const RecognizeVipFilter = z.enum([
  "vips",
  ...RecognizeVipCriterion.options,
]);
export type RecognizeVipFilter = z.infer<typeof RecognizeVipFilter>;

export const RecognizeVipOrder = z.object({
  id: z.string(),
  name: z.string().nullable(),
  orderedAt: z.string().nullable(),
  description: z.string(),
  status: z.enum(["Fulfilled", "Partial", "Unfulfilled"]),
  amount: z.number().nullable(),
  currency: z.string().nullable(),
});
export type RecognizeVipOrder = z.infer<typeof RecognizeVipOrder>;

export const RecognizeVipProfile = z.object({
  customerSince: z.string(),
  orders: z.array(RecognizeVipOrder),
  id: z.string(),
  name: z.string(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  identifiedAt: z.string(),
  orderId: z.string().nullable(),
  orderName: z.string().nullable(),
  orderedAt: z.string().nullable(),
  orderStats: z
    .object({
      totalOrders: z.number().int(),
      currency: z.string().nullable(),
      totalSpent: z.number().nullable(),
      averageOrder: z.number().nullable(),
    })
    .nullable(),
  verdicts: z.array(
    z.object({ criterion: RecognizeVipCriterion, reason: z.string() }),
  ),
  socials: z.array(
    z.object({
      platform: z.string(),
      url: z.string(),
      followers: z.number().nullable(),
    }),
  ),
  enrichment: z
    .object({
      biography: z.string().nullable(),
      identityConfidenceBand: z.string().nullish(),
      identityConfidence: z.number().nullish(),
    })
    .nullable(),
  linkedin: z
    .object({
      bio: z.string().nullable(),
      profileUrl: z.string().nullable(),
      photoUrl: z.string().nullable(),
      headline: z.string().nullable(),
      location: z.string().nullable(),
      experience: z
        .array(
          z.object({
            title: z.string().nullish(),
            company: z.string().nullish(),
            start_date: z.string().nullish(),
            end_date: z.string().nullish(),
            description: z.string().nullish(),
          }),
        )
        .nullable(),
      education: z
        .array(
          z.object({
            title: z.string().nullish(),
            degree: z.string().nullish(),
            field: z.string().nullish(),
            start_year: z.string().nullish(),
            end_year: z.string().nullish(),
          }),
        )
        .nullable(),
      companyName: z.string().nullable(),
    })
    .nullable(),
  propertyValue: z.number().nullable(),
  propertySources: z.array(z.string()),
});
export type RecognizeVipProfile = z.infer<typeof RecognizeVipProfile>;

export const RecognizeVipCursor = z.object({
  identifiedAt: z.string().min(1),
  id: z.string().regex(/^\d+$/),
});
export type RecognizeVipCursor = z.infer<typeof RecognizeVipCursor>;

export const RecognizeVipPage = z.object({
  profiles: z.array(RecognizeVipProfile),
  totalCount: z.number().int().nonnegative(),
  nextCursor: RecognizeVipCursor.nullable(),
});
export type RecognizeVipPage = z.infer<typeof RecognizeVipPage>;
